import { cache } from '@/container/apollo-client/cache';
import { useSetMfaReminderMutation } from '@/types/generated/graphql';
import { notification } from 'antd';

export const useSetupMfaReminder = () => {
  const [_setMfaReminder, { loading, data }] = useSetMfaReminderMutation({
    onCompleted: (res) => {
      cache.modify({ fields: { authMe: () => {} } });
      notification.success({ message: res?.setMfaReminder?.message });
    },
    onError: (error) => {
      notification.error({ message: error.message });
    },
  });
  const setMfaReminder = () => {
    _setMfaReminder();
  };
  return { setMfaReminder, loading, data };
};
